module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/arc-ed83ac80b726c78668f3bf037613185a.svg";